import React from 'react';
import { isMobile, isTablet } from 'react-device-detect';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import styled, { css, keyframes } from 'styled-components';
import Button from '../../../components/Button/Button';
import { isNotStandaloneMobilePWA } from '../../../utils/mobileSupported';

const BattlesBegin = ({ battlesAssets, battlesStarted, handleBattlesStarted }) => {
  return (
    <Container background={battlesAssets.BATTLES_BACKGROUND_SPLASH} battlesStarted={battlesStarted}>
      <BattlesLogo src={battlesAssets.BATTLES_SPLASH_LOGO} />
      <BattlesBeginButton
        label={getText(TEXT_KEY.LET_THE_BATTLES_BEGIN)}
        imageSource={assetSource(ASSET_KEY.ROUNDEDRECT_PRIMARY_WIDE)}
        onClick={handleBattlesStarted}
      />
    </Container>
  );
};

export default BattlesBegin;

const isMobileBrowser = isMobile && isNotStandaloneMobilePWA && !isTablet;

const logoEntrance = keyframes`
  0% {
    opacity: 0;
    transform: scale(0);
  }
  20% {
    opacity: 1;
    transform: scale(1.2);
  }
  35% {
    transform: scale(0.9);
  }
  50% {
    transform: scale(1.08);
  }
  65% {
    transform: scale(0.96);
  }
  80% {
    transform: scale(1.02);
  }
  90% {
    transform: scale(0.99);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

const Container = styled.div.withConfig({
  shouldForwardProp: prop => !['battlesStarted', 'background'].includes(prop),
})`
  display: ${({ battlesStarted }) => (battlesStarted ? 'none' : 'flex')};
  flex-direction: column;
  width: 100vw;
  height: 100%;
  justify-content: center;
  align-items: center;
  background-image: url(${({ background }) => background});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 100;
  position: relative;
  overflow: hidden;
`;

const BattlesLogo = styled.img`
  height: ${isMobileBrowser ? 55 : 65}vh;
  object-fit: contain;
  position: relative;
  z-index: 10;

  animation: ${logoEntrance} 3s ease-out forwards;
  opacity: 0;
  transform: scale(0);

  ${({ theme }) =>
    theme.platform('ios') &&
    theme.screens.device('mobile-browser') &&
    `
      margin-bottom: -2vh;
    `}
`;

const BattlesBeginButton = styled(Button).attrs({
  containerStyle: `
    width: ${isMobileBrowser ? 22 : 30}vw;
    animation: fade-in 3s ;
    pointer-events: none;
    animation-fill-mode: forwards;

    @keyframes fade-in {
      0% {
        opacity: 0;
        pointer-events: none;
      }
      60%
      {
        opacity: 0;
        pointer-events: none;
      }
      100% {
        opacity: 1;
        pointer-events: auto;
      }
    }
    `,
  imageStyle: `
    width: ${isMobileBrowser ? 22 : 30}vw;
    `,
  textStyle: css`
    font-size: ${isMobileBrowser ? 1.65 : 2.2}vw;
    font-weight: 800;
    text-stroke: 2px #038500;
    -webkit-text-stroke: 2px #038500;
    text-transform: uppercase;
    ${({ theme }) => theme.BattlesBegin.ButtonTextStyle}
  `,
})``;
